import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import '../styles/styles.css';

const useStyles = makeStyles((theme) => ({
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0.3rem 0',
  },
}));

/**
 * The frame both bet listings wear.
 *
 * The sports listing and the games listing show different columns - a games row has no score, no teams,
 * no odds and no handicap - but the frame around them is one thing: the bordered table, the dark header,
 * the rows, the total footer, the empty state and the pager. Each caller supplies its own column set, its
 * own rows and its own footer, so what a column *means* stays with the listing that owns it.
 *
 * <p>The sports path passes exactly what {@code BetList} rendered before this shell existed, attribute
 * for attribute, so none of the six screens that use it moves.</p>
 */
const BetTable = ({ columns, body, footer, totalPage, handleChange }) => {
  const classes = useStyles();

  return (
    <>
      <table className="table table-sm table-striped table-bordered">
        <thead className="text-center thead-dark">
          <tr>
            {columns.map((column, index) => (
              <th scope="col" key={column.label + index} className={column.className || ''}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        {body}
        {footer}
      </table>
      {totalPage && totalPage > 0 ? (
        <Pagination
          count={totalPage}
          onChange={handleChange}
          className={classes.pagination}
        />
      ) : null}
    </>
  );
};

export default BetTable;
